export default __webpack_public_path__ + "locales/ja-JP/SalesDepartmentRequestDialog.json?hash=aca39b0c589fb5cef4f14838c2bef3e3";